import { useState } from 'react';
import { App, Button } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';
import { useGetDocuments } from 'api/documents/use-get-documents';
import { useDownloadFile } from 'shared/hooks/use-download-file';
import { EDocumentSearchField } from 'types/document';
import { InvoiceDocumentsModal } from 'components/invoices/invoices-list/components/invoice-documents-modal';
import type { IInvoiceDownloadButtonProps } from './types';

export const InvoiceDownloadButton = (props: IInvoiceDownloadButtonProps) => {
  const { invoice } = props;
  const [isOpen, setIsOpen] = useState(false);

  const { message } = App.useApp();

  const downloadFile = useDownloadFile();
  const { data, refetch, isFetching, isError } = useGetDocuments({
    field: EDocumentSearchField.invoiceId,
    entityId: invoice.id,
    withUrl: true,
    enabled: false,
  });

  const handleClick = async () => {
    const result = await refetch();
    if (result.isError || !result.data) {
      message.error('Unable to load documents. Please try again.');
      return;
    }

    const documents = result.data.data;
    const total = result.data.pagination?.total ?? documents.length;

    if (total === 1 && documents.length === 1) {
      const document = documents[0];
      if (document.url) {
        downloadFile(document.url);
      }
      return;
    }

    setIsOpen(true);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <>
      <Button type='text' icon={<DownloadOutlined />} aria-label='Download invoice' onClick={handleClick} />
      <InvoiceDocumentsModal
        invoice={invoice}
        isOpen={isOpen}
        isLoading={isFetching}
        isError={isError}
        documents={data?.data || []}
        onClose={handleClose}
      />
    </>
  );
};
